import React, { FunctionComponent } from 'react';
import { Box, Typography } from '@material-ui/core';
import Price from '../../../../../../common/components/presentation/Price';
import { IServiceInterval } from '../../../../../model/IServicePlan';
import dealPriceAccessor from '../../../../../../common/service/dealPriceAccessor';
import serviceIntervalStyles from './serviceIntervalStyles';
import usePlatformConfig from '../../../../../../common/react/usePlatformConfig';

export interface IServiceIntervalProps {
  serviceInterval: IServiceInterval;
}

const ServiceInterval: FunctionComponent<IServiceIntervalProps> = ({ serviceInterval }) => {
  const styles = serviceIntervalStyles();
  const {
    platformConfig: { priceDisplay },
  } = usePlatformConfig();
  const primaryPrice = dealPriceAccessor.getPrimaryPrice(serviceInterval.prices, priceDisplay);

  return (
    <Box
      data-test="customise:servicePlanInterval"
      key={serviceInterval.description}
      display="flex"
      justifyContent="space-between"
      className={styles.itemContainer}
    >
      <Typography variant="caption" className={styles.itemLabel}>
        {serviceInterval.description}
      </Typography>
      <Price
        className={styles.itemValue}
        price={primaryPrice?.basePrice}
        currency={priceDisplay.primaryOptions.currency}
        decimals={priceDisplay.primaryOptions.decimalScale}
      />
    </Box>
  );
};

export default ServiceInterval;
